import * as React from "react";
import {useEffect, useState} from "react";
import {MediaCenter} from "../api";
import logo from "../assets/sartorius-logo.svg";
import RegionSelector from "./RegionSelector";
import {useOktaAuth} from "@okta/okta-react";
import {UserClaims} from "@okta/okta-auth-js";

interface IHeaderProps {
    mediaCenter?: MediaCenter;
}

export const Header = ({ mediaCenter }: IHeaderProps) => {
    const { oktaAuth, authState } = useOktaAuth();

    const [user, setUser] = useState<UserClaims>();

    function renderStatus() {
        if (!authState || !authState.isAuthenticated) {
            return null;
        }
        return (
            <div className="ml-4 login-info">
                <small>
                    Logged in as
                    <br/>
                    {user?.name}
                </small>
            </div>
        );
    }

    useEffect(() => {
        if (authState && authState.isAuthenticated) {
            // get user data from okta
            oktaAuth.token.getUserInfo().then((user) => {
                setUser(user);
            });
        }
    }, [authState, oktaAuth]);

    return (
        <nav className="navbar bg-primary px-8">
            <div className="navbar-brand">
                <div className="d-flex align-items-center">
                    <a href={window.location.pathname}>
                        <img src={logo} alt="Sartorius Logo" />
                    </a>
                    <div className="ml-8 pl-4">
                        <div>{mediaCenter && mediaCenter.title}</div>
                        <div className="tagline d-none d-md-block">
                            {mediaCenter && mediaCenter.description}
                        </div>
                    </div>
                </div>
            </div>
            <RegionSelector />
            {renderStatus()}
        </nav>
    );
};
export default Header;
